@if (sticky) {
  <div class="form-actions-spacer" aria-hidden="true"></div>
}

<div
  class="form-actions"
  [class.form-actions--sticky]="sticky"
  [class.form-actions--dialog]="layout === 'dialog'"
  [class.form-actions--inline]="layout === 'inline'"
  [class.form-actions--between]="actionsAlign === 'between'">
  @if (showCancel) {
    <button
      type="button"
      class="btn form-actions__btn"
      [class.btn-sm]="useSmallButtons"
      [ngClass]="cancelButtonClass"
      [disabled]="isSubmitting"
      (click)="cancel.emit()">
      {{ cancelLabel }}
    </button>
  }

  <ng-content select="[formActionsExtra]"></ng-content>

  @if (showSave) {
    <button
      [type]="saveType"
      class="btn form-actions__btn d-inline-flex align-items-center justify-content-center gap-2"
      [class.btn-sm]="useSmallButtons"
      [ngClass]="saveButtonClass"
      [attr.form]="formId || null"
      [disabled]="disabled || isSubmitting"
      (click)="onSaveClick()">
      @if (isSubmitting) {
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      }
      <span>{{ saveLabel }}</span>
    </button>
  }
</div>
